// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__26XOZ","title":"Widget_title__7R-5R"};